;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import RichText from 'components/ui/RichText';
import TextEyebrow from 'components/ui/TextEyebrow';

import styles from './CardColumnContent.module.scss';

const CardColumnContent = ({
    eyebrow,
    headline,
    richBodyCopy,
    cta,
    cta2,
    image,
    imageLarge,
    backgroundTheme,
}) => {
    backgroundTheme ??= 'white';

    return (
        <div
            className={cx(styles.columnContent, {
                [styles.creamBackground]: backgroundTheme === 'cream',
            })}
        >
            <div className={styles.columnContentInner}>
                {headline && (
                    <div className={styles.eyebrowWrapper}>
                        <TextEyebrow
                            eyebrow={eyebrow ? eyebrow : ''}
                            headline={headline}
                        />
                    </div>
                )}
                {richBodyCopy && (
                    <div className={styles.textWrapper}>
                        <RichText richText={richBodyCopy} />
                    </div>
                )}
                {cta && (
                    <div
                        className={cx(styles.buttonWrapper, {
                            [styles.ctaDuo]: cta?.text && cta2?.text,
                        })}
                    >
                        {cta && <ButtonCTA className={styles.cta} {...cta} />}
                        {cta2 && (
                            <ButtonCTA
                                className={cx(styles.cta, styles.cta2)}
                                {...cta2}
                            />
                        )}
                    </div>
                )}
            </div>
            {image?.url && imageLarge?.url && (
                <div className={styles.imgWrapper}>
                    <Img
                        className={styles.image}
                        src={image.url}
                        width={image?.width}
                        height={image?.height}
                        fallbackImageWidth={500}
                        alt={image.description || ''}
                        customSources={[
                            {
                                breakpoint: 768,
                                src: imageLarge.url,
                                imageWidth: imageLarge.width,
                            },
                            {
                                src: image.url,
                                imageWidth: image.width,
                            },
                        ]}
                    />
                </div>
            )}
        </div>
    );
};

CardColumnContent.propTypes = {
    eyebrow: PropTypes.string,
    headline: PropTypes.string.isRequired,
    hasArrowIcon: PropTypes.bool,
    richBodyCopy: PropTypes.object,
    cta: PropTypes.object,
    cta2: PropTypes.object,
    backgroundTheme: PropTypes.string,
    image: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    imageLarge: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
};

export default CardColumnContent;
